import { useTranslation } from 'react-i18next';

import styles from './OverdueToggle.module.css';
import { Icons } from './icons';

interface Props {
  /** The event becomes overdue after its end when it is not completed. */
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

/**
 * A small icon button (not a switch row) for the per-event "overdue after the end" choice. Off by
 * default: an event that ended is then simply a past event. It is not "completed": completing is
 * a separate, explicit action on the card.
 */
export function OverdueToggle({ value, onChange, disabled = false }: Props) {
  const { t } = useTranslation();
  const label = t('deadline.overdue.label');
  return (
    <button
      type="button"
      className={styles.button}
      aria-pressed={value}
      aria-label={label}
      title={`${label}. ${value ? t('deadline.overdue.on') : t('deadline.overdue.off')}`}
      disabled={disabled}
      data-testid="overdue-toggle"
      onClick={() => {
        onChange(!value);
      }}
    >
      <Icons.alert />
    </button>
  );
}
